/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';

const MetadataForm = ({ metadata, setMetadata, disabled = false }) => {
  const {
    manufacturer,
    model,
    description,
    creator,
    identifier,
    measurement,
    laboratory,
    report_number,
    report_date,
    creation_date,
    comments,
    spectral_quantity,
  } = metadata || {};

  // function FieldGroup() {
  //   return (
  //     <FormGroup controlId={1}>
  //       <ControlLabel>Make or Manufacturer</ControlLabel>
  //       <FormControl
  //         type="text"
  //         value={manufacturer}
  //         onChange={event =>
  //           setManufactureData({
  //             ...manufactureData,
  //             manufacturer: event.target.value
  //           })
  //         }
  //       />
  //     </FormGroup>
  //   );
  // }

  return (
    <div css={MetadataFormStyle}>
      <h4>Optional Metadata</h4>
      <FormGroup>
        <ControlLabel>
          Unique Identifier
          <br />
          <span style={{ fontSize: '14px', color: '#d77600' }}>
            This is used as the title in the reports and library
          </span>
        </ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={identifier}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              identifier: event.target.value,
            })
          }
        />
        <ControlLabel>Make or Manufacturer</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={manufacturer}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              manufacturer: event.target.value,
            })
          }
        />
        <ControlLabel>Model or Catalog Number or ID</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={model}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              model: event.target.value,
            })
          }
        />

        <ControlLabel>Description</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={description}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              description: event.target.value,
            })
          }
        />
        <ControlLabel>Document Creator</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={creator}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              creator: event.target.value,
            })
          }
        />
        <ControlLabel>Measurement Equipment</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={measurement}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              measurement: event.target.value,
            })
          }
        />
        <ControlLabel>Laboratory</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={laboratory}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              laboratory: event.target.value,
            })
          }
        />
        {/* </Col> */}
        {/* <Col md={6}> */}
        <ControlLabel>Report Number</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={report_number}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              report_number: event.target.value,
            })
          }
        />
        <ControlLabel>Report Date</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={report_date}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              report_date: event.target.value,
            })
          }
        />
        <ControlLabel>Creation Date</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={creation_date}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              creation_date: event.target.value,
            })
          }
        />
        <ControlLabel>Comments</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={comments}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              comments: event.target.value,
            })
          }
        />
        <ControlLabel>Spectral Quantity (e.g., W/nm)</ControlLabel>
        <FormControl
          disabled={disabled}
          type='text'
          value={spectral_quantity}
          onChange={(event) =>
            setMetadata({
              ...metadata,
              spectral_quantity: event.target.value,
            })
          }
        />
        {/* </Col> */}
      </FormGroup>
    </div>
  );
};

export default MetadataForm;

MetadataForm.propTypes = {
  shouldSave: PropTypes.bool,
  selectedExample: PropTypes.string,
  metaData: PropTypes.object,
  disabled: PropTypes.bool,
};

const MetadataFormStyle = css`
  label {
    margin-top: 1.5rem;
  }

  h4 {
    margin-bottom: 0;
    margin-top: 2rem;
  }

  input {
    .form-control[disabled] {
      background: #fff;
    }
  }
`;
